/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isrequired1Inputs */

const en_entity_isrequired1 = /** @type {(inputs: Entity_Isrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Required`)
};

const de_entity_isrequired1 = /** @type {(inputs: Entity_Isrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Is Required" |
*
* @param {Entity_Isrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isrequired1 = /** @type {((inputs?: Entity_Isrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isrequired1(inputs)
	return de_entity_isrequired1(inputs)
});
export { entity_isrequired1 as "entity_isRequired" }